import type { FaireProductEntity } from "../../entity_types/product";

export const p_evgmk5wjcu: FaireProductEntity = {
  token: "p_evgmk5wjcu",
  type: "product",
  name: "Elegant Sleeveless Pleated Maxi Dress for Women",
  brandToken: "b_999ccmmbkw",
  brandName: "Halcyon Outfitters®",
  imageUrl:
    "https://cdn.faire.com/fastly/b6b654dd4f5a75ee3a4c956197034ede2d1254d4aa3e8d558d20d6190a565c70.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1a36b58d3b116d34ce319df6b6f2645c5a3efa86d4bd68e44c9ab0e03da9558c.jpeg",
    "https://cdn.faire.com/fastly/e5018193e297c5479d9bfc53e4cfec259ad2805107dcec73db383e2c15c24226.jpeg",
    "https://cdn.faire.com/fastly/e6657d328daa70d133081d04ff43a0395be138414ebf3db7f9cd9a95fefac4da.jpeg",
    "https://cdn.faire.com/fastly/226910cb8a17e844a77336ac874585834bde1b023dce4141b3f7c34e2e1aefad.jpeg",
    "https://cdn.faire.com/fastly/1e797124f9ef99255819c6c2406aa265a7a4c398ed8a9cca06f6e270842c8e03.jpeg",
    "https://cdn.faire.com/fastly/7a06905fe7f037e992c8e6500332388a13f139de6a9aa40601313681f4d663e2.jpeg",
    "https://cdn.faire.com/fastly/013547fa6c23ddc507a6c7b3eb51336b4ca749c81d9ca93effca486ae7a35008.jpeg",
    "https://cdn.faire.com/fastly/0738d9383a93d1dcbf9c000138e59c2ebc4dc70eae77403c95a27896d01590c9.jpeg",
    "https://cdn.faire.com/fastly/15851802459818e829e915ad4c5810fa05a5a70f56d2f5a5600e2b61a7858978.jpeg",
    "https://cdn.faire.com/fastly/0fc78061873c8e9f867e56d03d725280e4da13476c56f1d5744f375599223603.jpeg",
  ],
  priceDollars: 13.5,
  description:
    "This stunning maxi dress is crafted from high-quality polyester, offering a delicate touch that feels amazing against the skin. With a flattering high-waist design and a flowy silhouette, it is perfect for any elegant occasion.\nFeatures: \n * Material: 95% Polyester for comfort and durability \n * Style: Elegant and sophisticated, ideal for casual and everyday wear \n * Care: Easy-care with wrinkle-free processing \n * Design: Sleeveless with a round neckline for a chic look \n * Length: Full-length maxi for an elegant appearance \n * Colors: Available in Beige, Gray, Black, Yellow, Dark Brown, Burgundy, and Sky Blue \n * Sizes: Available in S, M, L, XL, 2XL, and 3XL for various body types \nThis dress is versatile and can be styled for both casual outings and more formal events. The timeless design and comfortable fit make it a wardrobe essential for women looking to add a touch of elegance to their everyday style.\n",
  tags: [],
  msrpDollars: 27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:47.860Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
